var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1409_29496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#700517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1409_29496)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1409_29496)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.25C19.4518 21.25 22.25 18.4518 22.25 15C22.25 11.5482 19.4518 8.75 16 8.75C12.5482 8.75 9.75 11.5482 9.75 15C9.75 18.4518 12.5482 21.25 16 21.25ZM15.1199 15.0096L14.1981 15.9369C14.1386 15.9947 14.0912 16.0638 14.0587 16.1401C14.0262 16.2165 14.0092 16.2985 14.0087 16.3815C14.0082 16.4645 14.0243 16.5467 14.0559 16.6234C14.0876 16.7001 14.1342 16.7698 14.193 16.8283C14.2518 16.8868 14.3217 16.933 14.3986 16.9642C14.4755 16.9954 14.5578 17.011 14.6408 17.01C14.7238 17.0091 14.8057 16.9916 14.8819 16.9587C14.9581 16.9257 15.0269 16.8779 15.0844 16.8181L16.0017 15.8953L16.9013 16.7988C17.0182 16.9163 17.177 16.9825 17.3428 16.983C17.5086 16.9834 17.6678 16.9179 17.7853 16.8009C17.9028 16.684 17.9691 16.5252 17.9695 16.3594C17.9699 16.1936 17.9044 16.0344 17.7875 15.9169L16.883 15.0088L17.8094 14.0769C17.9229 13.9587 17.9855 13.8006 17.9837 13.6367C17.9818 13.4728 17.9156 13.3162 17.7994 13.2006C17.6832 13.0851 17.5262 13.0198 17.3623 13.0188C17.1984 13.0179 17.0407 13.0814 16.9231 13.1956L16.0009 14.1233L15.0625 13.1813C14.9449 13.0671 14.7871 13.0038 14.6232 13.0049C14.4593 13.0059 14.3024 13.0713 14.1863 13.187C14.0702 13.3026 14.0041 13.4592 14.0023 13.6231C14.0006 13.787 14.0633 13.945 14.1769 14.0631L15.1199 15.0096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1409_29496",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1409_29496"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.0196078 0 0 0 0 0.0901961 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_29496"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.0196078 0 0 0 0 0.0901961 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1409_29496",
    result: "effect2_dropShadow_1409_29496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1409_29496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_29496",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1409_29496",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBtn);
export default __webpack_public_path__ + "static/media/cancelBtn.3295f93875f6728c164798b8cee6b214.svg";
export { ForwardRef as ReactComponent };